import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import ResponsiveTable from "../../components/ResponsiveTable";
import { EyeIcon, PencilIcon, TrashIcon, ServerIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import moment from "moment"
import { toast } from 'react-toastify';

export default function BankToBankLog() {
    const navigate = useNavigate();
    const [transactions, setTransactions] = useState([]);
    const getBankTransaction = () => {
        axios.get("/banks/bank-transfers").then((res) => {
            setTransactions(res.data);
        });
    }
    useEffect(() => {
        getBankTransaction()
    }, []);
  const handleReverse = async (id) => {
    try {
      await axios.post(`/banks/bank-transfers/${id}/reverse`);
      toast.success('Transfer reversed');
      getBankTransaction();
    } catch (err) {
      toast.error('Reverse failed');
    }
  };
    const actions = [
        { label: 'Reverse', value: 'reverse', icon: <ServerIcon className="w-4 h-4 inline text-red-600" /> },
    ];
    const handleActionClick = (action, row) => {
        switch (action) {
            case "reverse":
                if (window.confirm("Are you sure you want to reverse this transfer?")) {
                    handleReverse(row.id)
                }
                break;
            default:
                break;
        }
    };
    const handleDownload = (type) => {
        const url = `${apiBaseUrl}/banks/export/${type}`;
        window.open(url, "_blank");
    };
    const columns = [
        {
            header: "Created Date", accessor: "created_at",
            render: (value, row) => <span>{moment(value, 'YYYY-MM-DD hh:mm:ss').format("DD/MM/YYYY hh:mm:ss")}</span>
        },
        { header: "From Bank", accessor: "from_bank" },
        { header: "To Bank", accessor: "to_bank" },
        { header: "Description", accessor: "description" },
        {
            header: "Amount", accessor: "amount",
            render: (value, row) => <span className="text-green-800 font-semibold">{value} BDT</span>
        },
    ];

    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <div className="w-full">
                <ExportButtons title="Bank List" onDownload={handleDownload} />
                <ResponsiveTable
                    columns={columns}
                    data={transactions}
                    showActions
                    actionButtons={actions}
                    onActionClick={handleActionClick}
                />
            </div>
        </div>
    );
}